import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

type DrawerFormRowColumns = 1 | 2

export interface DrawerFormLayoutProps {
  children: ReactNode
  className?: string
}

export interface DrawerFormRowProps {
  children: ReactNode
  className?: string
  columns?: DrawerFormRowColumns
}

const rowClassName: Record<DrawerFormRowColumns, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 sm:grid-cols-2',
}

export function DrawerFormLayout({ children, className }: DrawerFormLayoutProps) {
  return <div className={cn('space-y-5', className)}>{children}</div>
}

export function DrawerFormRow({ children, className, columns = 2 }: DrawerFormRowProps) {
  return (
    <div className={cn('grid gap-x-5 gap-y-[18px]', rowClassName[columns], className)}>
      {children}
    </div>
  )
}
